module.exports = __webpack_public_path__ + "img/Package-Active.e020ec96.svg";